import SecundButton from 'components/form/buttons/secundButton';
import MiniPopUp from 'components/modal/miniPopUp';
import PanelBoxLayout from 'components/layout/panelBox';

import { Formik } from 'formik';
import Gap from 'components/gap';
import PrimaryButton from 'components/form/buttons/primaryButton';
import { SetStateAction } from 'react';
import DropDown from 'components/form/dropDown';
import DateInput from 'components/form/dateInput';
import OutlineButton from 'components/form/buttons/outLineButton';

import * as S from './styles';
import * as T from 'common/types';

interface IProps {
  setFilter: SetStateAction<any>;
  filter: any;
}

export default function TicketFilterPopup({ setFilter, filter }: IProps) {
  return (
    <S.Content>
      <MiniPopUp
        popUpStyle={{ width: 245, padding: '0' }}
        buttonNode={
          <SecundButton
            hasIcon={true}
            icon="/icons/stroke/filter.svg"
            iconStyle={{ background: 'none' }}
            style={{ background: '#8A93AC' }}
            colorIcon="var(--white)"
          >
            Filters
          </SecundButton>
        }
      >
        <PanelBoxLayout
          style={{ padding: 15 }}
          titleStyle={{ color: '#2D3748', fontSize: 14 }}
          title="Filters"
          icon="/icons/stroke/filter.svg"
        >
          <Formik
            initialValues={{
              date: '',
              status: ''
            }}
            // validationSchema={ValidationLogin}
            onSubmit={(values, { setSubmitting }) => {
              setFilter({ ...filter, ...values, page: 1 });
              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              // handleChange,
              handleSubmit,
              // isSubmitting,
              setValues,
              resetForm
            }) => (
              <>
                <DropDown
                  label="Status"
                  list={[
                    { id: '', title: 'All' },
                    { id: 'active', title: 'Active' },
                    { id: 'completed', title: 'Completed' },
                    { id: 'canceled', title: 'Canceled' }
                  ]}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      status: e.id as any
                    });
                  }}
                  placeholder="Select Status"
                  message={touched.status && (errors.status as any)}
                  error={errors.status as unknown as boolean}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                />
                <Gap size="10px" />
                <DateInput
                  onChange={(e) => {
                    setValues({
                      ...values,
                      date: e
                    });
                  }}
                  placeholder="Start Date"
                  label="Start Date"
                  defaultDate={values.date}
                  message={touched.date && (errors.date as any)}
                  error={touched.date && (errors.date as unknown as boolean)}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                />
                <Gap size="20px" />

                <PrimaryButton
                  style={{ width: '100%', height: 42, borderRadius: 8 }}
                  onClick={handleSubmit}
                  // disabled={isSubmitting}
                >
                  Filter
                </PrimaryButton>

                <Gap size="15px" />

                <OutlineButton
                  style={{ width: '100%', height: 42, borderRadius: 8 }}
                  onClick={() => {
                    resetForm();
                    handleSubmit();
                  }}
                  // disabled={isSubmitting}
                >
                  Reset
                </OutlineButton>
              </>
            )}
          </Formik>
        </PanelBoxLayout>
      </MiniPopUp>
    </S.Content>
  );
}
